// eslint-disable-next-line @typescript-eslint/no-empty-function
const NOOP = () => {}


export { NOOP }
